type DeviceType = 'mobile' | 'tablet' | 'desktop';
type DeviceOrientation = 'portrait' | 'landscape';

type DeviceInfo = {
  type: DeviceType;
  orientation: DeviceOrientation;
  isMobileDevice: boolean;
};
const DEFAULT_DEVICE_INFO: DeviceInfo = {
  type: 'desktop',
  orientation: 'portrait',
  isMobileDevice: false,
};

export const getDeviceInfo = (): DeviceInfo => {
  if (typeof window === 'undefined') {
    return DEFAULT_DEVICE_INFO;
  }
  const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  const width = window.innerWidth;
  const height = window.innerHeight;

  const orientation: DeviceOrientation = width > height ? 'landscape' : 'portrait';

  /*  if (!isTouch) {
    return {
      type: 'desktop',
      orientation,
    };
  }*/

  const shortestSide = Math.min(width, height);

  /*  if (shortestSide < 768) {
    return {
      type: 'mobile',
      orientation,
    };
  }*/
  const type = !isTouch ? 'desktop' : 'mobile';
  //const type = !isTouch ? 'desktop' : shortestSide < 768 ? 'mobile' : 'tablet';
  const isMobileDevice =
    (type === 'mobile' && orientation === 'landscape') || (type === 'mobile' && orientation === 'portrait');

  return {
    type,
    orientation,
    isMobileDevice,
  };
};
